module.exports = __webpack_public_path__ + "img/img_logo@2x.6f70f8b0.png";